module.exports = __webpack_public_path__ + "fonts/SFUIDisplay-Black.47f441af.woff2";